import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { StockServices } from "../services";
import { TranslateService } from '@ngx-translate/core';
import { ProviderOrderAddPage } from '../../providers/orders/provider-order-add/provider-order-add';
import { ProviderOrderCartPage } from '../../providers/orders/provider-order-cart/provider-order-cart';
import { AdsServices } from '../../ads/services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { IngredientViewPage } from '../../ingredients/ingredient-view/ingredient-view/ingredient-view';
import { ProductViewPage } from '../../products/product-view/product-view/product-view';

/**
 * Generated class for the MinMaxListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-min-max-list',
  templateUrl: 'min-max-list.html',
})
export class MinMaxListPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public stockServices: StockServices,
    public globals: Globals,
    public translate: TranslateService,
    public adsServices: AdsServices) {

    if (!this.globals.checkLimitsByLicense('stock', 'alert')) {
      this.navCtrl.pop();
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
    //this.globals.GAtrackView('Stock', 'Stock - List', this.globals.restaurant.email, 'View', 'List stock', 'Stock', '');
  }

  async ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-cargando-stock')
    });
    loadingPopup.present();

    this.stockServices.getListStockMaxMin();
    this.adsServices.randomProvidersElements();
    loadingPopup.dismiss();
  }

  openProviderOrderAdd(element, type) {
    this.navCtrl.push(ProviderOrderAddPage, {
      element: element,
      type: type
    });
  }

  searchStockNode(value) {
    this.stockServices.searchStockNode(value);
  }

  openCart() {
    this.navCtrl.push(ProviderOrderCartPage);
  }

  openProdingView(proding) {
    if (proding.type === 'ingredient') {
      this.navCtrl.push(IngredientViewPage, {
        ingredient_uid: proding.UID,
        ingredient_name: proding.name
      });
    } else if (proding.type === 'product') {
      this.navCtrl.push(ProductViewPage, {
        product_uid: proding.UID,
        product_name: this.globals.nameLangSelectProduct(proding),
        product_sub_recipe: proding.sub_recipe
      });
    } else {
      //do nothing
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/stock/min-max-list/min-max-list.ts